/**
 * Created by kevinqueeney on 08/09/2015.
 */
angular.module('qkr.inventory').factory('variantCoefficientService', ['variantCoefficientHelperService', 'variantSortingService', 'variantHelperService',
        function(variantCoefficientHelperService, variantSortingService, variantHelperService) {
    const calculateVariantSetSummaryCoefficient = function(variantInfrastructure, numberOfVariantSetSummaries, indexOfVariantSetSummaries) {
        return Math.pow(10, (variantInfrastructure.variantCoefficientExponent * (numberOfVariantSetSummaries - (indexOfVariantSetSummaries + 1))));
    };

    // Generates a number that enables us to sort the variants once the option coefficients are summed
    const calculateOptionCoefficient = function(variantSetSummary, optionIndex) {
        return ((optionIndex + 1) * variantSetSummary.summaryCoefficient);
    };

    const calculateCoefficientForVariantDetails = function(variantSetSummaries, variantDetails) {
        let variantCoefficient = 0;

        // The order of the variantSetSummaries is the same as the order of the variantDetails.
        angular.forEach(variantDetails, (variantDetail, index) => {
            const variantSetSummary = variantSetSummaries[index];

            for (let i = 0; i < variantSetSummary.options.length; i++) {
                const variantSetSummaryOption = variantSetSummary.options[i];

                if (variantSetSummaryOption.optionValue == variantDetail.variantValue) {
                    variantCoefficient += variantSetSummaryOption.optionCoefficient;
                    break;
                }
            }
        });

        return variantCoefficient;
    };

    const createVariantCoefficientMap = function(coefficient, variant) {
        return {
            coefficient,
            variant
        };
    };

    const getInsertionIndexOfVariantCoefficient = function(variantCoefficientList, newVariantCoefficient) {
        for (let index = 0; index <= variantCoefficientList.length; index++) {
            // Check if the insertion point is the end of the list.
            if (index == variantCoefficientList.length) {
                return index;
            } else {
                const variantCoefficient = variantCoefficientList[index];
                if (variantCoefficient.coefficient == newVariantCoefficient) {
                    return -1;
                }

                if (variantCoefficient.coefficient > newVariantCoefficient) {
                    return index;
                }
            }
        }

        return -1;
    };

    const recalculateVariantExclusionCoefficients = function(variantInfrastructure) {
        const removeVariantExclusionIndexList = [];

        angular.forEach(variantInfrastructure.variantCoefficientExclusionList, (excludedVariantCoefficient, index) => {
            let newVariantCoefficientValue = 0;
            let removeVariantExclusionIndex = -1;

            for (let i = 0; i < excludedVariantCoefficient.variant.variantDetails.length; i++) {
                const variantDetail = excludedVariantCoefficient.variant.variantDetails[i];
                const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);

                if (variantSetSummary != null) {
                    const variantOption = variantHelperService.getVariantSetSummaryOptionForOptionValue(variantSetSummary, variantDetail.variantValue);

                    if (variantOption != null) {
                        newVariantCoefficientValue += variantOption.optionCoefficient;
                    } else {
                        removeVariantExclusionIndex = index;
                        break;
                    }
                } else {
                    removeVariantExclusionIndex = index;
                    break;
                }
            }

            if (removeVariantExclusionIndex != -1) {
                removeVariantExclusionIndexList.push(removeVariantExclusionIndex);
            } else {
                excludedVariantCoefficient.coefficient = newVariantCoefficientValue;
            }
        });

        while (removeVariantExclusionIndexList.length != 0) {
            const removeVariantExclusionIndex = removeVariantExclusionIndexList.pop();
            variantInfrastructure.variantCoefficientExclusionList.splice(removeVariantExclusionIndex, 1);
        }
    };

    const recalculateVariantOptionExclusionCoefficients = function(variantInfrastructure) {
        if (variantInfrastructure.variantSetSummaries.length > 0) {
            const removeVariantOptionExclusionIndexList = [];
            angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary) => {
                angular.forEach(variantInfrastructure.variantOptionExclusionList, (excludedVariantOption, index) => {
                    if (excludedVariantOption.type == variantSetSummary.type) {
                        const variantOption = variantHelperService.getVariantSetSummaryOptionForOptionValue(variantSetSummary, excludedVariantOption.option.optionValue);
                        if (variantOption != null) {
                            excludedVariantOption.optionCoefficient = variantOption.optionCoefficient;
                        } else {
                            removeVariantOptionExclusionIndexList.push(index);
                        }
                    }
                });
            });

            while (removeVariantOptionExclusionIndexList.length != 0) {
                const removeVariantOptionExclusionIndex = removeVariantOptionExclusionIndexList.pop();
                variantInfrastructure.variantOptionExclusionList.splice(removeVariantOptionExclusionIndex, 1);
            }
        } else {
            variantInfrastructure.variantOptionExclusionList = [];
        }
    };

    const recalculateVariantSetSummaryOptionCoefficients = function(variantInfrastructure, variantSetSummary, variantSetSummaryIndex) {
        variantSetSummary.summaryCoefficient = calculateVariantSetSummaryCoefficient(variantInfrastructure, variantInfrastructure.variantSetSummaries.length, variantSetSummaryIndex);

        angular.forEach(variantSetSummary.options, (variantSetSummaryOption, index) => {
            variantSetSummaryOption.optionCoefficient = calculateOptionCoefficient(variantSetSummary, index);
        });

        recalculateVariantOptionExclusionCoefficients(variantInfrastructure);
        recalculateVariantExclusionCoefficients(variantInfrastructure);
    };

    const recalculateVariantCoefficients = function(variantInfrastructure) {
        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
            variantSortingService.sortVariantDetails(variantInfrastructure.variantSetSummaries, variantCoefficient.variant);
            const coefficient = calculateCoefficientForVariantDetails(variantInfrastructure.variantSetSummaries, variantCoefficient.variant.variantDetails);
            variantCoefficient.coefficient = coefficient;
        });
    };

    const sortVariantCoefficientList = function(variantCoefficientList) {
        variantCoefficientList.sort((variantCoefficientA, variantCoefficientB) => variantCoefficientA.coefficient - variantCoefficientB.coefficient);
    };

    const setVariantCoefficientListPriorities = function(variantCoefficientList) {
        angular.forEach(variantCoefficientList, (variantCoefficient, variantIndex) => {
            variantCoefficient.variant.priority = variantIndex;

            angular.forEach(variantCoefficient.variant.variantDetails, (variantDetail, variantDetailIndex) => {
                variantDetail.priority = variantDetailIndex;
            });
        });
    };

    return {
        calculateVariantSetSummaryCoefficient(variantInfrastructure, numberOfVariantSetSummaries, indexOfVariantSetSummaries) {
            return calculateVariantSetSummaryCoefficient(variantInfrastructure, numberOfVariantSetSummaries, indexOfVariantSetSummaries);
        },

        // Generates a number that enables us to sort the variants once the option coefficients are summed
        calculateOptionCoefficient(variantSetSummary, optionIndex) {
            return calculateOptionCoefficient(variantSetSummary, optionIndex);
        },

        calculateCoefficientForVariantDetails(variantSetSummaries, variantDetails) {
            return calculateCoefficientForVariantDetails(variantSetSummaries, variantDetails);
        },

        createVariantCoefficientMap(coefficient, variant) {
            return createVariantCoefficientMap(coefficient, variant);
        },

        getInsertionIndexOfVariantCoefficient(variantCoefficientList, newVariantCoefficient) {
            return getInsertionIndexOfVariantCoefficient(variantCoefficientList, newVariantCoefficient);
        },

        recalculateVariantExclusionCoefficients(variantInfrastructure) {
            recalculateVariantExclusionCoefficients(variantInfrastructure);
        },

        recalculateVariantOptionExclusionCoefficients(variantInfrastructure) {
            recalculateVariantOptionExclusionCoefficients(variantInfrastructure);
        },

        recalculateVariantSetSummaryOptionCoefficients(variantInfrastructure, variantSetSummary, variantSetSummaryIndex) {
            recalculateVariantSetSummaryOptionCoefficients(variantInfrastructure, variantSetSummary, variantSetSummaryIndex);
        },

        recalculateVariantCoefficients(variantInfrastructure) {
            recalculateVariantCoefficients(variantInfrastructure);
        },

        sortVariantCoefficientList(variantCoefficientList) {
            sortVariantCoefficientList(variantCoefficientList);
        },

        setVariantCoefficientListPriorities(variantCoefficientList) {
            setVariantCoefficientListPriorities(variantCoefficientList);
        },

        isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue) {
            return variantCoefficientHelperService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantCoefficient.services.js